<template>
  <div class="modal-panel">
    <div class="modal-data">
        <div class="Add-instruction-title">
            Add Insructions for the Test:
        </div>
        <div class="ck-editor">
            <ckeditor :editorUrl="editorURL"  v-model="editorData" :config="{toolbarStartupExpanded:true,startupFocus:true}"></ckeditor>
        </div>
    </div>
    <v-row>
        <v-col cols="12" sm="9"> </v-col>
        <v-col cols="12" sm="3" class="btn-center chnage-ui-center">
            <v-btn @click="onClose({status:false,instructions:editorData})" class="right-btn cust-btn" color="primary">Done</v-btn>
        </v-col>
    </v-row>
  </div>
</template>
<script>

export default {
 name: 'AddInstructions',
 props:['onClose','data','status'],
    data() {
       return {
         
                editorData: this.data&&this.data.instructions?this.data.instructions:null
                
       }
    },
    watch:{
        status(val)
        {
             
            if(!val)
            {
                this.editorData=null;
            }
            else{
                 this.editorData= this.data&&this.data.instructions?this.data.instructions:null
            }
        }
    }
    
}
</script>
